/* global windowWidth, breakpointMd */
const searchInput = document.querySelector('.header-search__input-field');
const searchModal = document.querySelector('.header-search__modal');
const searchField = document.querySelector('input#search');
const searchForm = searchField.closest('.header-search__form');
const searchClear = searchForm.querySelector('.header-search__clear');

const toggleSearchClass = (toggle) => {
  document.body.classList.toggle('is-search-open', toggle);

  if (!toggle && searchInput) {
    searchInput.blur();
  }
};

const toggleMenuClass = (toggle) => {
  document.body.classList.toggle('is-open-menu', toggle);
};

const toggleQuickNavClass = (toggle) => {
  document.body.classList.toggle('is-open-quick-nav', toggle);
};

// ------
// Mobile menu toggle
// ------

attachEvent('.mobile-hamburger', 'click', (ev) => {
  ev.preventDefault();
  const isOpen = document.body.classList.contains('is-open-menu');
  toggleQuickNavClass(false);
  toggleSearchClass(false);
  toggleMenuClass(!isOpen);
});

// ------
// Add class to body after some scroll
// ------
function addScrollingClass() {
  const topOffert = document.documentElement.scrollTop || document.body.scrollTop;
  document.body.classList.toggle('is-scrolled', topOffert > 160);
}

let ticking = false;
document.addEventListener('scroll', () => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      addScrollingClass();
      ticking = false;
    });
    ticking = true;
  }
});

let lastScrollTop = 0;
window.addEventListener(
  'scroll',
  () => {
    const isScrolledTop = window.pageYOffset || document.documentElement.scrollTop;
    document.body.classList.toggle('is-scrolled-up', isScrolledTop < lastScrollTop);
    lastScrollTop = isScrolledTop <= 0 ? 0 : isScrolledTop;
  },
  false,
);

// ------
// Open Quick nav
// ------

attachEvent('.quick-nav-hamburger', 'click', (ev) => {
  const isOpen = document.body.classList.contains('is-open-quick-nav');
  toggleSearchClass(false);
  toggleMenuClass(false);
  toggleQuickNavClass(!isOpen);
  ev.preventDefault();
});

// ------
// Open search
// ------

attachEvent('.header-main__search-btn', 'click', (ev) => {
  const isOpen = document.body.classList.contains('is-search-open');
  searchInput.focus();
  toggleMenuClass(false);
  toggleQuickNavClass(false);
  toggleSearchClass(!isOpen);
  ev.preventDefault();
});

attachEvent('#search', 'click', () => {
  if (searchField.value) {
    searchModal.classList.toggle('is-active');
  }
});
// ------
// Open header dropdown
// ------

attachEvent('.dropdown-simple__placeholder', 'click', (ev) => {
  const parentElem = ev.target.closest('.dropdown-simple');
  parentElem.classList.toggle('is-open');

  if (windowWidth() < breakpointMd) {
    const headerDropdown = parentElem.querySelector('.dropdown-simple__list');
    slideToggle(headerDropdown, 300, 'block');
  }
});

// *******************************************************************************
// Close Search When Click Out
// *******************************************************************************

document.addEventListener('click', (evt) => {
  const headerSearchBtn = document.querySelector('.header-main__search-btn');
  const headerSearchContainer = document.querySelector('.header-search__form');

  let targetElement = evt.target; // clicked element

  do {
    if (targetElement === headerSearchContainer || targetElement === headerSearchBtn) {
      return;
    }
    targetElement = targetElement.parentNode;
  } while (targetElement);

  if (searchModal) {
    toggleSearchClass(false);
    searchModal.classList.remove('is-active');
  }
});

// *******************************************************************************
// Close Search When Escape Key Press
// *******************************************************************************

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    toggleSearchClass(false);
    searchModal.classList.remove('is-active');
  }
});

const profileDropwown = document.querySelector('.profile-dropdown');
const axiosProfileData = (headerNonce) => {
  const formAction = 'getHeaderProfileData';
  grecaptcha.ready(async () => {
    const token = await grecaptcha.execute(localData.captchaSiteKey, { action: formAction });
    const formDataInput = new FormData();
    formDataInput.append('action', formAction);
    formDataInput.append('nonce', headerNonce);
    formDataInput.append('lang', localData.lang);
    formDataInput.append('id', localData.id);
    formDataInput.append('token', token);
    axios
      .post(localData.apiURL, formDataInput, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        const profileDropDownList = profileDropwown.querySelector('.dropdown-simple__list');
        if (response.status === 200) {
          profileDropDownList.innerHTML = response.data.data.html;
        } else if (response.status !== 200 && response.data.data.html !== '') {
          profileDropDownList.innerHTML = response.data.data.html;
        } else {
          profileDropDownList.innerHTML = '<ul><li>Prišlo je do napake</li></ul>';
        }
        renderWishlistItems();
        renderCartBadge(response.data.data.cart_number);
      });
  });
};

// ------
// Wishlist item
// ------
const renderWishlistItems = () => {
  const likedItemsCookie = Cookies.get('liked_items');
  const likedItemsCount = likedItemsCookie ? JSON.parse(likedItemsCookie).length || 0 : 0;
  const badgeElement = document.querySelector('.header-main__badge');
  if (badgeElement) {
    badgeElement.remove();
  }
  if (likedItemsCount) {
    document
      .querySelector('.header-main__wishlist-btn')
      .insertAdjacentHTML('afterbegin', `<div class="header-main__badge">${likedItemsCount}</div>`);
  }
};

// ------
// Cart badge
// ------
const renderCartBadge = (number) => {
  const badgeElement = document.querySelector('.header-main__cart-btn .header-main__badge');
  if (badgeElement) {
    badgeElement.remove();
  }
  if (number && document.querySelector('.header-main__cart-btn')) {
    document
      .querySelector('.header-main__cart-btn')
      .insertAdjacentHTML('afterbegin', `<div class="header-main__badge">${number}</div>`);
  }
};

// ------
// Live header search
// ------
const searchHeaderPosts = (search) => {
  if (search.value) {
    axios
      .post(
        localData.apiURL,
        {
          action: 'searchPostsHeader',
          s: search.value,
        },
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      )
      .then((response) => {
        if (response.status === 200) {
          searchModal.querySelector('.header-search__posts').style.display = response.data.posts ? 'block' : 'none';
          searchModal.querySelector('.header-search__modal-categories').style.display = response.data.categories
            ? 'block'
            : 'none';
          searchModal.querySelector('.header-search__modal-right').style.display = response.data.products
            ? 'block'
            : 'none';
          searchModal.querySelector('.header-search__modal-posts-list').innerHTML = response.data.posts;
          searchModal.querySelector('.header-search__modal-categories-list').innerHTML = response.data.categories;
          searchModal.querySelector('.header-search__modal-products').innerHTML = response.data.products;
          searchModal.classList.toggle(
            'is-active',
            response.data.posts || response.data.categories || response.data.products,
          );
        }
      });
  }
};

if (searchField) {
  searchField.addEventListener(
    'keyup',
    debounce(() => {
      searchHeaderPosts(searchField);
    }, 300),
  );
}

document.addEventListener('DOMContentLoaded', async () => {
  if (profileDropwown) {
    const headerNonce = await getNonceForAction('profile_dropdown');
    axiosProfileData(headerNonce);
  }
});

// ------
// Clear search field
// ------
searchField.addEventListener('input', () => {
  searchForm.classList.toggle('searching', searchField.value.trim() !== '');
});
searchClear.addEventListener('click', () => {
  searchField.value = '';
  searchForm.classList.remove('searching');
});
